<template>
  <!-- 天数明细 -->
  <section>
    <ax-panel :noTitle="true">
      <div class="padding16">
        <!-- total -->
        <div class="total-box">
          <span>{{ pageObj.detailListTitle }}</span>
          共计{{ total }}天
        </div>
        <ul>
          <li class="flex" v-for="(item, index) in detailListData" :key="index">
            <div class="flex-item">
              <i class="circle"></i>
              {{ item.dur || item.qh_dur}}{{ item.qh_end_place ? "/" + item.qh_end_place : "" }}
            </div>
            <div>{{item.qh_dur_description}}</div>
            <div class="flex-item-1">{{ item.qh_overtime_days }}天</div>
          </li>
        </ul>
      </div>
    </ax-panel>
  </section>
</template>

<script>
import completedObj from "@/assets/js/approval/completed.js";
import upcomingObj from "@/assets/js/approval/upComDetail.js";
import request from "@/utils/request";
export default {
  data() {
    return {
      instanceId: this.$route.query.instanceId,
      recordKey: "",
      pageId: this.$route.query.pageId,
      pageObj: {},
      toast: null,
      detailListKey: "",
      detailListData: [],
      total: 0
    };
  },
  watch: {
    $route() {
      this.getPageId();
      this.fetchDataByPageId();
    }
  },
  created() {
    this.toast = this.$toast.loading({
      mask: false,
      message: "加载中...",
      duration: 0
    });
    this.getPageId();
    this.fetchDataByPageId();
  },
  methods: {
    // 获取pageId
    getPageId() {
      this.instanceId = this.$route.query.instanceId;
      this.pageId = this.$route.query.pageId;
      this.pageObj = completedObj[this.pageId] || upcomingObj[this.pageId];
      this.detailListKey = this.pageObj.detailListKey;
      this.$setIosTitle(this.pageObj.detailListTitle || "假期明细");
    },
    // 根绝pageId 获取数据
    fetchDataByPageId() {
      if (!this.pageObj) {
        this.toast && this.toast.clear();
        this.toast = this.$toast("暂无明细");
        return;
      }
      let options = {
        url: this.pageObj.serviceUrl,
        method: this.pageObj.method
      };

      // 请求参数需要  都是从 query 里获取
      /**
       * pin_take_name 缺勤编码
       * bgn_dt 开始时间
       * end 结束时间
       * qh_start_place 始发地
       * qh_end_place 目的地
       */

      let body = {};

      this.pageObj.data.forEach(item => {
        body[item[0]] = this[item[1]];
      });
      if (this.pageObj.method === "get") {
        options.params = body;
      } else {
        options.data = body;
      }

      request(options)
        .then(({ data }) => {
          if (data.code === 200) {
            this.showResult = false;
            this.detailListData = data.data[this.detailListKey];
            if(this.detailListData.length>0){
              let d = 0
              this.detailListData.forEach(item=>{
                d+=Number(item.qh_overtime_days)
              })
              this.total = d 
            }
          } else {
            this.toast && this.toast.clear();
            this.toast = this.$toast("暂无明细");
          }
        })
        .catch(e => {
          this.toast && this.toast.clear();
          this.toast = this.$toast("暂无明细");
        })
        .finally(_ => {
          this.toast && this.toast.clear();
        });
    }
  },
  beforeDestroy() {
    this.toast && this.toast.clear();
  }
};
</script>

<style lang="scss" scoped>
.padding16 {
  padding: 16px;
}
.total-box {
  text-align: right;
  position: relative;
  font-size: 14px;
  span {
    position: absolute;
    left: 0;
    color: #888;
  }
}
.flex {
  display: flex;
  .flex-item {
    flex: 1;
  }
  .flex-item-1 {
    width: 3rem;
    text-align: right;
  }
}
ul li {
  font-size: 14px;
  margin: 20px 0;
  position: relative;
  .circle {
    display: inline-block;
    position: relative;
    top: -1px;
    width: 6px;
    height: 6px;
    background: #aaa;
    border-radius: 50%;
    vertical-align: middle;
  }
}
</style>
